/* global femcare */

femcare.loader = {
    /**
     * Toggles loader visibility inside a parent element.
     * @param {string | HTMLElement} parent - Parent element or selector string.
     * @param {boolean} isLoading - Whether to show or hide the loader.
     */
    toggleLoader: function (parent, isLoading) {
        const parentContainer = typeof parent === 'string' ? document.querySelector(parent) : parent;
        const loader = parentContainer.querySelector('.loader');

        if (loader) {
            loader.classList.toggle('hidden', !isLoading);
            loader.setAttribute('aria-hidden', !isLoading);
        }
    }
};
